import RefNavbar from './RefNavbar';
import RefTerms from './RefTerms';

function Page2026Terms() {
  return (
    <>
      <RefNavbar />
      <RefTerms />
    </>
  );
}

export default Page2026Terms;
